import { getInitialState } from './initialState';

export default getInitialState();
